import QueryString from 'query-string';

const isWhitelistedDomain = (domain) => {
  domain = domain.trim();

  try {
    if (!domain.startsWith('http://') && !domain.startsWith('https://')) {
      domain = 'https://' + domain;
    }
    const url = new URL(domain);
    domain = url.hostname;
  } catch (err) {
    return false;
  }

  const domainRegex = /^(?!-)(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
  if (!domainRegex.test(domain)) {
    return false;
  }

  const whitelist = [
    'stg-cart.quicken.com',
    'qa-cart.quicken.com',
    'preprod-cart.quickencs.com',
    'cart.quicken.com',
    'https://stg-cart.quicken.com',
    'https://qa-cart.quicken.com',
    'https://preprod-cart.quickencs.com',
    'https://cart.quicken.com',
  ];
  return whitelist.includes(domain);
};

const eStoreUrl = (link = '', params) => {
  let {domain, embed, ...QS} = QueryString.parse(window.location.search);
  const hasDomainAndIsValid = domain ? isWhitelistedDomain(domain) : false;
  domain = hasDomainAndIsValid ? domain : process.env.REACT_APP_CART_URL;
  domain = domain?.replace('/canada', '');
  domain = (domain.startsWith('http://') || domain.startsWith('https://')) ? domain : `https://${domain}`;

  const PARAMS = {
    embed: embed || QS['hide-nav'] ? 1 : null, //This appears to be stored when going to page
    ...params,
    bearer: process.env.REACT_APP_ENV !== 'production' ? localStorage.getItem('bearer') : null,
  };

  return `${domain}${link}?${QueryString.stringify(PARAMS, {
    skipNull: true,
    skipEmptyString: true,
  })}`;
};

export const getEStoreRenewal = (country='', productLine='', tier='') =>
  eStoreUrl(
    '/create',
    {
      renew: 1,
      productLineUriName: productLine,
      tierUriName: tier,
      country: country
    }
  );

export const getEStoreCartUrlAddProduct = (sku = '', country = '') =>
  eStoreUrl(
    '/create',
    {addproduct: sku}
  );
